import type { IdTokenClaims } from 'oidc-client-ts';

/// El rol de Keycloak que abre la consola. Tiene que coincidir con el del realm
/// (`infra/keycloak/realm/realm-tallerya.json`) y con la condición del flujo
/// `plataforma`: un nombre distinto acá deja afuera a todo el equipo.
export const ROL_PLATAFORMA = 'platform-admin';

/// Si quien entró es del equipo de TallerYa.
///
/// ## No es la barrera, es la segunda
///
/// **La que vale está en Keycloak**: el client `tallerya-plataforma` tiene su
/// propio flujo de ingreso que niega la entrada a quien no tenga el rol, así que
/// una persona del taller no llega a tener un token para este sitio. Y cuando la
/// consola le hable a la API (M-9), la API vuelve a comprobarlo en cada petición.
///
/// Esto existe para lo que se escapa de las dos: un cambio en el realm que deje
/// el flujo mal configurado, o un token viejo. En ese caso la consola se niega a
/// dibujarse en vez de mostrarse vacía.
///
/// ## Por qué también mira que no tenga taller
///
/// Un usuario con talleres es de un taller, tenga el rol que tenga. Si alguien
/// le asignara `platform-admin` por error a un mecánico, lo correcto es que no
/// entre: el rol dice qué puede hacer, pero el taller dice quién es. Es el mismo
/// corte que usa `HttpCurrentActor` en la API para firmar la auditoría.
///
/// Desde #205 los talleres viajan en `tenant_ids`. Se sigue mirando también
/// `tenant_id`, el de antes: un token emitido antes del cambio todavía lo puede
/// traer, y en la duda la consola no se abre.
///
/// El rol viaja en el **id token** porque el client lleva un mapeador propio para
/// eso; por omisión Keycloak solo lo pone en el access token, que el navegador no
/// debería abrir.
export function esDelEquipo(perfil: IdTokenClaims | undefined): boolean {
  if (!perfil) return false;

  if (perfil['tenant_ids'] !== undefined || perfil['tenant_id'] !== undefined) return false;

  const acceso = perfil['realm_access'] as { roles?: unknown } | undefined;
  const roles = Array.isArray(acceso?.roles) ? acceso.roles : [];

  return roles.includes(ROL_PLATAFORMA);
}
